class Popupnav extends HTMLElement {
    constructor() {
        super();
        this.close = this.querySelector('[data-popupnav-close]');
        this.wrapper = this.querySelector('[data-popupnav-wrapper]');
        this.contentWrapper = this.querySelector('[data-popupnav-content-wrapper]');
        this.triger = document.querySelectorAll('[data-popupnav-triger]');
        this.overlay = this.querySelector('[data-popupnav-overlay]');
    }
    connectedCallback() {
        this.close.addEventListener('click', () => {
            this.overlay.style.display = 'none';
        });
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) {
                this.overlay.style.display = 'none';
            }
        });

        this.triger.forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                this.overlay.style.display = 'block';
            });
        });

    }
}

customElements.get('popupnav-component') || customElements.define('popupnav-component', Popupnav);
